import { connectedStore } from '../../store';
import actions from '../actions';

const clientUploadAsset = (asset) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.clientUploadAsset(asset, resolve, reject));
  });

export default clientUploadAsset;
